import { render, staticRenderFns } from "./CourseInstructorCourses.vue?vue&type=template&id=3a7d8976&scoped=true"
import script from "./CourseInstructorCourses.vue?vue&type=script&lang=js"
export * from "./CourseInstructorCourses.vue?vue&type=script&lang=js"
import style0 from "./CourseInstructorCourses.vue?vue&type=style&index=0&id=3a7d8976&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7d8976",
  null
  
)

export default component.exports